/* eslint no-console:0 */
// This file is automatically compiled by Vite Rails, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= vite_javascript_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import 'trix';
import '@rails/actiontext';
import { Turbo } from '@hotwired/turbo-rails';
import {} from 'jquery-ujs';
import Cookies from 'js-cookie';
import jstz from 'jstz';
import 'cocoon-js';
import { Application } from '@hotwired/stimulus';
import { buildLinks, buildRequestRoutes } from '../packs/shared/routes';
import setupReact from '../helpers/setupReact';
import '../controllers';
import HoneybadgerLogger from '../lib/honeybadger';
import AjaxFailureNotifier from '../packs/shared/AjaxFailureNotifier';

const tz = jstz.determine().name();
Cookies.set('timezone', tz, { expires: 7 });

const componentsRequireContext = import.meta.glob('../components/**/*.{js,jsx,ts,tsx}');
setupReact(componentsRequireContext);

window.junoRoutes = buildLinks();
window.serverClient = buildRequestRoutes();
window.cdnIconHref = (iconName) => gon.cdn_icon_href_template.replace(/<ICON-NAME>/g, iconName);

// Configure auto-hide for datepicker
$.fn.datepicker.setDefaults({ autoHide: true });

Turbo.config.forms.mode = 'off';

const application = Application.start();

new HoneybadgerLogger().init();
new AjaxFailureNotifier().init();

export { application };
